import React from 'react';
import { DialogTitle, Typography, IconButton } from '@material-ui/core';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

interface EeModalTitleProps {
  children: React.ReactNode;
  onClose: () => void;
}

export const EeModalTitle: React.FC<EeModalTitleProps> = ({
  children,
  onClose,
}) => {
  return (
    <DialogTitle
      disableTypography
      className="d-flex w-100 align-items-center pr-3"
    >
      <Typography variant="h6" className="mr-auto w-100 lens-modal-popup-title">
        {children}
      </Typography>
      {onClose ? (
        <IconButton aria-label="Close" onClick={onClose}>
          <CancelOutlinedIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
